import React, { FC } from 'react';

import CTA from 'Src/components/buttons/CTA';
import { StackedIconCTA } from 'Src/components/buttons/StackedIconCTA';
import { CheckItemVoidReasonModal } from 'Src/feature/check/CheckItemVoidReasonModal';
import { CheckItemScheduleModal } from 'Src/feature/check-item/CheckItemScheduleModal';
import { useCheckItemEditActions } from 'Src/feature/check-item/useCheckItemEditActions';
import { UsedCurrentCheckItemButtons } from 'Src/feature/check-item/useCurrentCheckItemButtons';
import { CheckItemDiscountModal } from 'Src/feature/check-item-discount/CheckItemDiscountModal';

import { CheckItemEditPriceModal } from './CheckItemEditPriceModal';
import { CheckItemSplitModal } from './CheckItemSplitModal';

import styles from './CheckItemEditActions.module.scss';

const sectionId = 'CheckItemEditActions';

interface CheckItemEditActionsProps {
  onGoBack: () => void;
  checkItemButtons: UsedCurrentCheckItemButtons;
}

const CheckItemEditActions: FC<CheckItemEditActionsProps> = (props) => {
  const store = useCheckItemEditActions(props);
  return (
    <>
      <div data-testid={sectionId} className={styles.root}>
        {store.shouldShowRepositionArrows && (
          <div className={styles.itemPositionActions}>
            <CTA
              icon="keyboard_arrow_up"
              className={styles.cta}
              onClick={store.onMoveItemsUp}
              disabled={store.disable.moveUp}
            />
            <CTA
              icon="keyboard_arrow_down"
              className={styles.cta}
              onClick={store.onMoveItemsDown}
              disabled={store.disable.moveDown}
            />
          </div>
        )}
        <div className={styles.itemActions}>
          {store.buttons.map((buttonProps, i) => (
            <StackedIconCTA key={`action-button-${i}`} size="sm" padding="sm" {...buttonProps} />
          ))}
        </div>
      </div>
      <CheckItemVoidReasonModal
        open={store.modal.voidReason.isOpen}
        onVoid={store.modal.voidReason.onSave}
        onClose={store.modal.voidReason.close}
        form={store.voidItemForm}
        reasonOptions={store.voidReasonOptions ?? []}
      />
      <CheckItemScheduleModal
        open={store.modal.schedule.isOpen}
        onSave={store.modal.schedule.onSave}
        onClose={store.modal.schedule.close}
        form={store.scheduleItemForm}
        checkItemName={store.activeCheckItem?.menuItem.name ?? ''}
      />
      <CheckItemEditPriceModal
        open={store.modal.editPrice.isOpen}
        form={store.overrideItemPriceForm}
        basePrice={store.activeCheckItem?.gross as number}
        onClose={store.modal.editPrice.close}
        onSave={store.modal.editPrice.onSave}
      />
      <CheckItemSplitModal
        key={props.checkItemButtons.selectedCheckItemIds.join()}
        open={store.modal.splitItem.isOpen}
        checkId={props.checkItemButtons.activeCheck?.id}
        items={props.checkItemButtons.selectedCheckItems}
        onCancel={store.modal.splitItem.close}
        onAfterSave={store.modal.splitItem.onAfterSave}
      />
      <CheckItemDiscountModal
        open={store.modal.discount.isOpen}
        onDone={store.modal.discount.close}
        check={store.activeCheck}
        checkItemIds={props.checkItemButtons.selectedCheckItemIds}
      />
    </>
  );
};

export { CheckItemEditActions, sectionId };
export type { CheckItemEditActionsProps };
